import { Typography } from "@monolith-forensics/monolith-ui";
import { useRelayInfo } from "../../hooks";
import { RelayUrl } from "../../../System";
import { SectionContainer } from "./SectionContainer";

export const RelayAccess: React.FC = () => {
  const { relayInfo } = useRelayInfo();

  if (!relayInfo) return null;

  return (
    <SectionContainer>
      <div>
        <Typography variant="h3">Access Your Relay Tenant</Typography>
        <div className="message">
          This is the URL you can use to access Relay. Relay uses a different
          authentication system from Monolith, so you will log in with a
          different password.
        </div>
      </div>
      <RelayUrl relayInfo={relayInfo} />
    </SectionContainer>
  );
};
